import { reportTypesMapToPlatform } from './constants';
import { REPORT_TYPES } from '../config/constants/reportConstants';

const APPSFLYER_REPORT_TYPES = [
    REPORT_TYPES.META_MEDIA_APPS_FLYER_MASTER,
    REPORT_TYPES.GOOGLE_MEDIA_APPS_FLYER_MASTER,
    REPORT_TYPES.GOOGLE_UAC_APPS_FLYER_MASTER,
];

export const filterReportsByType = ({ reports, selectedPlatform, selectedType }) => {
    return reports.filter(report => {
        if (!selectedPlatform) return false;

        const reportPlatform = reportTypesMapToPlatform.get(report.report_type);
        if (!reportPlatform) return false;

        if (APPSFLYER_REPORT_TYPES.includes(report.report_type)) {
            return selectedPlatform === 'AppsFlyer';
        }

        const reportTypeLower = report.report_type.toLowerCase();

        if (reportPlatform === 'Meta') {
            if (selectedPlatform === 'AppsFlyer') {
                return /appsflyer/i.test(reportTypeLower);
            } else if (selectedPlatform === 'Meta') {
                return !/appsflyer/i.test(reportTypeLower);
            } else {
                return false; // Exclude Meta reports when other platforms are selected
            }
        }

        if (selectedPlatform === 'Outbrain' || selectedPlatform === 'Taboola') {
            if (!selectedType) return false;

            const platformPattern = new RegExp(selectedPlatform.toLowerCase(), 'i');

            if (!platformPattern.test(reportTypeLower)) return false;

            if (selectedPlatform === 'Outbrain') {
                if (selectedType === 'ad-data') {
                    return /ad/i.test(reportTypeLower);
                } else if (selectedType === 'section-data') {
                    return /section/i.test(reportTypeLower);
                }
                return false;
            } else if (selectedPlatform === 'Taboola') {
                if (selectedType === 'ad-data') {
                    return /ad/i.test(reportTypeLower);
                } else if (selectedType === 'sites-data') {
                    return /sites/i.test(reportTypeLower);
                }
                return false;
            }
        }

        return reportPlatform === selectedPlatform;
    });
};